module.exports = __webpack_public_path__ + "static/mothersday-fb22c42da74cc8ae59df27051e20eeb4.png";